// extracted by mini-css-extract-plugin
var _1 = "CarouselThumbnail-module__animateUploadProgressBarWidth--XMWPw";
var _2 = "CarouselThumbnail-module__animatedBackground--ecFO0";
var _3 = "CarouselThumbnail-module__container--L2J3Y";
var _4 = "CarouselThumbnail-module__isDragging--pBEfA";
var _5 = "CarouselThumbnail-module__isUploading--mHWJT";
var _6 = "CarouselThumbnail-module__thumbnailButton--QtB2I";
var _7 = "CarouselThumbnail-module__uploadingProgress--oPdvb";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isDragging", _5 as "isUploading", _6 as "thumbnailButton", _7 as "uploadingProgress" }
